<script>
import { mapActions, mapGetters } from 'vuex'

import Fade from 'linna/components/Fade'
import Spacer from 'linna/components/Spacer'

import config from '@/config'
import chapters from '@/config/chapters'

import Settings from '@/components/meta/Settings'
import Buttons from '@/components/snippets/Buttons.vue'
import GlitchText from '@/components/snippets/GlitchText'
import StyledButton from '@/components/snippets/StyledButton'
// import Typewriter from '@/components/snippets/Typewriter'

export default {
  name: 'ViewSplash',

  components: {
    Buttons,
    Fade,
    GlitchText,
    Settings,
    Spacer,
    StyledButton
    // Typewriter
  },

  data () {
    return {
      appName: config.appName,
      chapters,
      view: null,
      appVersion: config.appVersion
    }
  },

  computed: {

    ...mapGetters([
      'hasSavedGame'
    ])

  },

  methods: {

    ...mapActions([
      'resetChapterState',
      'resetUserProgress',
      'resetUserPreferences'
    ]),

    showSettings () {
      this.view = 'settings'
    },

    showChapters () {
      this.view = 'chapters'
    },

    showDefaultOptions () {
      this.view = null
    },

    onChapterSelect (i) {
      this.$store.dispatch('initializeChapterStateFromBeginning', i)

      this.$router.push({
        name: 'game'
      })
    },

    onStartNew () {
      this.resetChapterState()
      this.resetUserProgress()

      this.$router.push({
        name: 'storyIntro'
      })
    },

    onClearData () {
      this.resetUserPreferences()
    }

  }

}
</script>

<template>
  <div class="c-view-splash">
    <div class="c-view-splash-content">

      <h1 class="c-view-splash-headline">
        <glitch-text :text="appName" />
      </h1>

      <div class="c-view-splash-main">

        <fade>

          <!-- Settings -->
          <div
            v-if="view === 'settings'"
            key="settings"
            class="c-view-splash-settings"
          >
            <settings />

            <buttons class="c-view-splash-settings-actions">

              <div>
                App version 0.{{ appVersion }}.0
              </div>

              <spacer />

              <styled-button
                :to="{
                  name: 'credits'
                }"
              >
                Show credits
              </styled-button>

            </buttons>

            <buttons class="c-view-splash-settings-actions">

              <styled-button @click="showDefaultOptions">
                Back
              </styled-button>

              <spacer />

              <styled-button @click="onClearData">
                Clear settings
              </styled-button>

            </buttons>

          </div>

          <!-- Chapters -->
          <div
            v-else-if="view === 'chapters'"
            key="chapters"
            class="c-view-splash-main-chapters"
          >

            <ul>

              <li>
                <styled-button @click="onStartNew()">
                  Intro sequence
                </styled-button>
              </li>

              <li
                v-for="(chapter, i) in chapters"
                :key="i"
                class="c-view-splash-chapter"
              >
                <styled-button @click="onChapterSelect(i)">
                  Chapter {{ i + 1 }}
                </styled-button>
              </li>

              <li>
                <styled-button @click="showDefaultOptions">
                  Back
                </styled-button>
              </li>

            </ul>

          </div>

          <!-- Default options -->
          <div
            v-else
            key="actions"
            class="c-view-splash-main-actions"
          >

            <ul>

              <li
                v-if="hasSavedGame"
                class="c-view-splash-continue"
              >
                <styled-button
                  :to="{
                    name: 'game'
                  }"
                >
                  Continue game
                </styled-button>
              </li>

              <li>
                <styled-button @click="onStartNew()">
                  Start new game
                </styled-button>
              </li>

              <li>
                <styled-button @click="showChapters">
                  Chapters
                </styled-button>
              </li>

              <li>
                <styled-button @click="showSettings">
                  Settings
                </styled-button>
              </li>

            </ul>

          </div>

        </fade>

      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-view-splash {
  @include fill-relative;
}

.c-view-splash-content {
  @include keep-full-center;
  @include buffer-horizontal;
  @include buffer-loose-vertical;
  width: $width-content;
  max-width: 100%;

  li {
    + li {
      @include push-tight-top;
    }
  }

}

.c-view-splash-main {
  min-height: 18rem;
}

.c-view-splash-settings-actions {
  @include push-top;
}

.c-view-splash-continue {
  @include push-bottom;

  .c-styled-button {
    background-color: translucent($green, 0.25);
  }

}

</style>
